// jobRoles.js - Comprehensive Job Roles Database
export const BASE_JOB_ROLES = {
  engineering: [
    // Software Engineering
    "Frontend Developer", "Backend Developer", "Full Stack Developer", "Software Engineer", "Senior Software Engineer", "Staff Software Engineer", "Principal Software Engineer",
    "Software Architect", "Lead Software Engineer", "Software Development Manager", "Engineering Manager", "Senior Engineering Manager", "Director of Engineering", "VP of Engineering", "CTO", "Chief Technology Officer",
    
    // DevOps & Infrastructure
    "DevOps Engineer", "Site Reliability Engineer", "Platform Engineer", "Cloud Engineer", "Infrastructure Engineer", "Systems Engineer", "Network Engineer", "Database Administrator", "Cloud Architect", "Solutions Architect", "Technical Architect", "Enterprise Architect",
    "Kubernetes Engineer", "Docker Engineer", "AWS Engineer", "Azure Engineer", "GCP Engineer", "Terraform Engineer", "Ansible Engineer", "Jenkins Engineer", "GitLab Engineer", "CI/CD Engineer",
    
    // Data & AI/ML
    "Data Engineer", "Machine Learning Engineer", "AI Engineer", "MLOps Engineer", "Data Scientist", "Applied Scientist", "Research Scientist", "Computer Vision Engineer", "NLP Engineer", "Deep Learning Engineer", "Robotics Engineer", "Autonomous Systems Engineer",
    
    // Mobile Development
    "Mobile Developer", "iOS Developer", "Android Developer", "React Native Developer", "Flutter Developer", "Xamarin Developer", "Ionic Developer", "Mobile App Architect", "Mobile UI/UX Developer",
    
    // Web Development
    "React Developer", "Angular Developer", "Vue.js Developer", "Next.js Developer", "Svelte Developer", "Node.js Developer", "Express.js Developer", "Django Developer", "Flask Developer", "FastAPI Developer",
    "PHP Developer", "Laravel Developer", "WordPress Developer", "Drupal Developer", "Magento Developer", "Shopify Developer", "Web Application Developer", "Progressive Web App Developer",
    
    // Programming Languages
    "Python Developer", "Java Developer", "JavaScript Developer", "TypeScript Developer", "C++ Developer", "C# Developer", "Go Developer", "Rust Developer", "Kotlin Developer", "Swift Developer", "Scala Developer", "Ruby Developer", "Rails Developer", "Perl Developer", "R Developer", "MATLAB Developer", "Fortran Developer", "Assembly Developer", ".NET Developer", "VB.NET Developer",
    
    // Database & Big Data
    "Database Developer", "SQL Developer", "MongoDB Developer", "PostgreSQL Developer", "MySQL Developer", "Oracle Developer", "Redis Developer", "Elasticsearch Developer", "Cassandra Developer", "Neo4j Developer", "Big Data Engineer", "Hadoop Developer", "Spark Developer", "Kafka Developer", "Snowflake Developer", "Databricks Engineer",
    
    // Security & Testing
    "Security Engineer", "Cybersecurity Engineer", "Information Security Engineer", "Penetration Tester", "Security Analyst", "Cryptography Engineer", "Blockchain Developer", "Smart Contract Developer", "Web3 Developer", "DeFi Developer", "Solidity Developer",
    "Quality Assurance Engineer", "Test Engineer", "Automation Engineer", "Test Automation Engineer", "Performance Test Engineer", "Manual Tester", "API Test Engineer", "Mobile Test Engineer", "Game Tester", "Accessibility Tester", "Security Tester",
    
    // Specialized Engineering
    "Game Developer", "Unity Developer", "Unreal Developer", "AR/VR Developer", "Mixed Reality Developer", "Augmented Reality Developer", "Virtual Reality Developer", "3D Developer", "Graphics Programmer", "Shader Developer", "Game Engine Developer",
    "Embedded Systems Engineer", "Firmware Engineer", "Hardware Engineer", "FPGA Engineer", "ASIC Engineer", "PCB Designer", "Electronics Engineer", "Microcontroller Developer", "IoT Engineer", "Edge Computing Engineer",
    "Quantum Computing Engineer", "Quantum Software Developer", "Quantum Algorithm Developer", "Quantum Hardware Engineer", "Quantum Research Engineer",
    
    // Emerging Technologies
    "Metaverse Developer", "NFT Developer", "Cryptocurrency Developer", "Fintech Developer", "Healthtech Developer", "Edtech Developer", "Proptech Developer", "Cleantech Developer", "Agritech Developer", "Biotech Developer", "Nanotech Engineer",

    // AI / LLM (new roles)
    "Prompt Engineer", "LLM Engineer", "Generative AI Engineer", "AI Safety Engineer", "AI Safety Researcher", "RAG Engineer", "AI Infrastructure Engineer", "Foundation Model Engineer", "AI Platform Engineer", "AI Solutions Architect"
  ],

  design: [
    // UI/UX Design
    "UX Designer", "UI Designer", "Product Designer", "UX/UI Designer", "Senior UX Designer", "Lead UX Designer", "Principal UX Designer", "UX Design Manager", "UX Director", "Head of UX", "VP of Design", "Chief Design Officer",
    "Visual Designer", "Graphic Designer", "Web Designer", "Mobile Designer", "Interaction Designer", "Service Designer", "Design Systems Designer", "Design Ops", "Design Strategist", "Design Researcher", "UX Researcher", "User Researcher",
    
    // Creative & Visual
    "Creative Director", "Art Director", "Associate Creative Director", "Senior Art Director", "Brand Designer", "Brand Identity Designer", "Logo Designer", "Corporate Identity Designer", "Visual Identity Designer",
    "Motion Designer", "Motion Graphics Designer", "3D Designer", "3D Artist", "3D Animator", "CGI Artist", "VFX Artist", "Compositor", "Lighting Artist", "Texture Artist", "Character Designer", "Environment Artist",
    
    // Digital Media
    "Digital Designer", "Web Designer", "Email Designer", "Social Media Designer", "Display Ad Designer", "Banner Designer", "Landing Page Designer", "E-commerce Designer", "App Designer", "Game UI Designer",
    "Video Editor", "Video Producer", "Motion Graphics Artist", "After Effects Artist", "Premiere Pro Editor", "Final Cut Pro Editor", "Color Grader", "Sound Designer", "Audio Engineer", "Podcast Producer",
    
    // Print & Traditional
    "Print Designer", "Publication Designer", "Book Designer", "Magazine Designer", "Newspaper Designer", "Brochure Designer", "Flyer Designer", "Poster Designer", "Packaging Designer", "Label Designer",
    "Typography Designer", "Type Designer", "Font Designer", "Lettering Artist", "Calligrapher", "Hand Lettering Artist",
    
    // Specialized Design
    "Fashion Designer", "Textile Designer", "Jewelry Designer", "Accessories Designer", "Footwear Designer", "Costume Designer", "Set Designer", "Props Designer",
    "Interior Designer", "Furniture Designer", "Lighting Designer", "Landscape Designer", "Garden Designer", "Architect", "Urban Planner", "Space Planner",
    "Industrial Designer", "Product Designer", "Automotive Designer", "Toy Designer", "Electronics Designer", "Medical Device Designer", "Furniture Designer",
    "Game Designer", "Level Designer", "Character Designer", "Narrative Designer", "Systems Designer", "Gameplay Designer", "Game Artist", "Concept Artist",
    
    // Content & Communication
    "UX Writer", "Content Designer", "Content Strategist", "Information Architect", "Content Creator", "Copywriter", "Creative Writer", "Technical Writer", "Grant Writer", "Speechwriter",
    "Illustrator", "Digital Illustrator", "Traditional Illustrator", "Children's Book Illustrator", "Medical Illustrator", "Scientific Illustrator", "Technical Illustrator", "Storyboard Artist",
    "Animator", "2D Animator", "3D Animator", "Stop Motion Animator", "Flash Animator", "Character Animator", "Background Artist", "Clean-up Artist", "In-betweener",
    
    // Emerging Design
    "AR/VR Designer", "Metaverse Designer", "Voice UI Designer", "Conversational Designer", "AI/ML Designer", "Generative Designer", "Algorithmic Designer", "Computational Designer", "Parametric Designer"
  ],

  product: [
    // Product Management
    "Product Manager", "Senior Product Manager", "Lead Product Manager", "Principal Product Manager", "Product Director", "Head of Product", "VP of Product", "Chief Product Officer",
    "Product Owner", "Technical Product Manager", "Growth Product Manager", "Data Product Manager", "AI Product Manager", "Platform Product Manager", "API Product Manager", "Mobile Product Manager",
    "B2B Product Manager", "B2C Product Manager", "Enterprise Product Manager", "Consumer Product Manager", "SaaS Product Manager", "E-commerce Product Manager", "Marketplace Product Manager",
    
    // Product Strategy & Operations
    "Product Marketing Manager", "Product Marketing Director", "Product Strategist", "Product Operations Manager", "Product Operations Director", "Product Analyst", "Product Data Analyst",
    "Product Researcher", "Product Insights Manager", "Product Intelligence Manager", "Voice of Customer Manager", "Customer Insights Manager", "Market Research Manager",
    
    // Product Development
    "Product Designer", "Product Development Manager", "Product Development Director", "New Product Development Manager", "Innovation Manager", "Product Innovation Director",
    "Product Launch Manager", "Go-to-Market Manager", "Product Adoption Manager", "Product Success Manager", "Product Engagement Manager",
    
    // Specialized Product
    "Hardware Product Manager", "Software Product Manager", "Digital Product Manager", "Physical Product Manager", "Service Product Manager", "Platform Product Manager",
    "Fintech Product Manager", "Healthtech Product Manager", "Edtech Product Manager", "Gaming Product Manager", "Media Product Manager", "Social Product Manager",
    
    // Product Consulting
    "Product Consultant", "Product Strategy Consultant", "Product Management Consultant", "Product Advisory", "Fractional Product Manager", "Interim Product Manager"
  ],

  marketing: [
    // Marketing Management
    "Marketing Manager", "Senior Marketing Manager", "Marketing Director", "VP of Marketing", "CMO", "Chief Marketing Officer", "Marketing Strategist", "Brand Manager", "Brand Director",
    
    // Digital Marketing
    "Digital Marketing Manager", "Digital Marketing Director", "Online Marketing Manager", "Internet Marketing Manager", "Digital Marketing Specialist", "Digital Marketing Strategist",
    "Performance Marketing Manager", "Growth Marketing Manager", "Growth Hacker", "User Acquisition Manager", "Customer Acquisition Manager", "Retention Marketing Manager",
    
    // Content Marketing
    "Content Marketing Manager", "Content Marketing Director", "Content Strategist", "Content Manager", "Content Creator", "Content Producer", "Editorial Manager", "Blog Manager",
    "Video Marketing Manager", "Podcast Marketing Manager", "Social Media Content Manager", "Visual Content Manager", "Content Operations Manager",
    
    // Social Media
    "Social Media Manager", "Social Media Director", "Social Media Strategist", "Social Media Coordinator", "Social Media Specialist", "Community Manager", "Community Director",
    "Influencer Marketing Manager", "Influencer Relations Manager", "Creator Relations Manager", "Partnership Marketing Manager", "Ambassador Program Manager",
    
    // SEO & SEM
    "SEO Manager", "SEO Director", "SEO Specialist", "SEO Analyst", "Technical SEO Manager", "Local SEO Manager", "E-commerce SEO Manager",
    "SEM Manager", "PPC Manager", "PPC Director", "Google Ads Manager", "Facebook Ads Manager", "LinkedIn Ads Manager", "Paid Search Manager", "Paid Social Manager",
    
    // Email & Automation
    "Email Marketing Manager", "Email Marketing Director", "Email Marketing Specialist", "Marketing Automation Manager", "Marketing Automation Director", "CRM Marketing Manager",
    "Lifecycle Marketing Manager", "Drip Campaign Manager", "Newsletter Manager", "Customer Journey Manager", "Lead Nurturing Manager",
    
    // Analytics & Operations
    "Marketing Analyst", "Marketing Data Analyst", "Marketing Analytics Manager", "Marketing Intelligence Manager", "Marketing Operations Manager", "Marketing Operations Director",
    "Marketing Technology Manager", "MarTech Manager", "Marketing Attribution Manager", "Conversion Rate Optimization Manager", "A/B Testing Manager",
    
    // Demand Generation
    "Demand Generation Manager", "Demand Generation Director", "Lead Generation Manager", "Lead Generation Director", "Inbound Marketing Manager", "Outbound Marketing Manager",
    "Account-Based Marketing Manager", "ABM Manager", "Field Marketing Manager", "Event Marketing Manager", "Webinar Marketing Manager", "Trade Show Manager",
    
    // Product Marketing
    "Product Marketing Manager", "Product Marketing Director", "Go-to-Market Manager", "Launch Marketing Manager", "Competitive Intelligence Manager", "Market Research Manager",
    "Sales Enablement Manager", "Sales Marketing Manager", "Channel Marketing Manager", "Partner Marketing Manager", "Affiliate Marketing Manager",
    
    // PR & Communications
    "PR Manager", "Public Relations Manager", "Communications Manager", "Corporate Communications Manager", "Internal Communications Manager", "External Communications Manager",
    "Media Relations Manager", "Press Relations Manager", "Analyst Relations Manager", "Investor Relations Manager", "Crisis Communications Manager",
    
    // Creative & Design
    "Creative Marketing Manager", "Marketing Designer", "Brand Designer", "Campaign Designer", "Marketing Creative Director", "Advertising Creative Director",
    "Copywriter", "Marketing Copywriter", "Brand Copywriter", "Direct Response Copywriter", "Content Writer", "Technical Writer", "Grant Writer",
    
    // Specialized Marketing
    "E-commerce Marketing Manager", "Retail Marketing Manager", "B2B Marketing Manager", "B2C Marketing Manager", "Enterprise Marketing Manager", "SMB Marketing Manager",
    "Mobile Marketing Manager", "App Marketing Manager", "Gaming Marketing Manager", "SaaS Marketing Manager", "Fintech Marketing Manager", "Healthcare Marketing Manager",
    "Nonprofit Marketing Manager", "Political Marketing Manager", "Real Estate Marketing Manager", "Hospitality Marketing Manager", "Travel Marketing Manager",
    
    // Emerging Marketing
    "Voice Marketing Manager", "Podcast Marketing Manager", "Video Marketing Manager", "AR/VR Marketing Manager", "Metaverse Marketing Manager", "Web3 Marketing Manager",
    "AI Marketing Manager", "Programmatic Marketing Manager", "Personalization Manager", "Customer Experience Manager", "Omnichannel Marketing Manager"
  ],

  sales: [
    // Sales Management
    "Sales Manager", "Senior Sales Manager", "Sales Director", "Regional Sales Director", "VP of Sales", "Chief Sales Officer", "Head of Sales", "Sales Operations Manager", "Sales Operations Director",
    
    // Sales Representatives
    "Sales Representative", "Senior Sales Representative", "Sales Specialist", "Sales Consultant", "Account Executive", "Senior Account Executive", "Enterprise Account Executive",
    "Inside Sales Representative", "Outside Sales Representative", "Field Sales Representative", "Territory Sales Representative", "Regional Sales Manager", "National Sales Manager",
    
    // Business Development
    "Business Development Manager", "Business Development Director", "Business Development Representative", "BDR", "Sales Development Representative", "SDR", "Lead Development Representative",
    "Partnership Manager", "Strategic Partnership Manager", "Channel Manager", "Channel Partner Manager", "Alliance Manager", "Reseller Manager", "Distributor Manager",
    
    // Account Management
    "Account Manager", "Senior Account Manager", "Key Account Manager", "Major Account Manager", "Strategic Account Manager", "Enterprise Account Manager", "Global Account Manager",
    "Client Manager", "Client Director", "Relationship Manager", "Customer Account Manager", "Named Account Manager", "Territory Manager", "Geographic Sales Manager",
    
    // Specialized Sales
    "Technical Sales Manager", "Technical Sales Representative", "Sales Engineer", "Solutions Engineer", "Presales Engineer", "Sales Specialist", "Product Sales Manager",
    "B2B Sales Manager", "B2C Sales Manager", "Enterprise Sales Manager", "SMB Sales Manager", "Mid-Market Sales Manager", "Commercial Sales Manager",
    "SaaS Sales Manager", "Software Sales Manager", "Hardware Sales Manager", "Medical Device Sales Representative", "Pharmaceutical Sales Representative",
    
    // Industry-Specific Sales
    "Real Estate Sales Agent", "Insurance Sales Agent", "Financial Services Sales Representative", "Investment Sales Representative", "Banking Sales Officer",
    "Automotive Sales Representative", "Equipment Sales Representative", "Industrial Sales Representative", "Construction Sales Representative", "Manufacturing Sales Representative",
    "Technology Sales Representative", "Telecommunications Sales Representative", "Healthcare Sales Representative", "Education Sales Representative", "Government Sales Representative",
    
    // Sales Support & Operations
    "Sales Coordinator", "Sales Administrator", "Sales Support Specialist", "Sales Operations Analyst", "Sales Analyst", "Sales Forecasting Analyst", "Sales Performance Analyst",
    "Sales Enablement Manager", "Sales Training Manager", "Sales Trainer", "Sales Coach", "Sales Methodology Manager", "Sales Process Manager", "Sales Tools Manager",
    
    // Customer Success & Retention
    "Customer Success Manager", "Customer Success Director", "Client Success Manager", "Customer Success Representative", "Account Success Manager", "Customer Retention Manager",
    "Customer Onboarding Manager", "Implementation Manager", "Customer Adoption Manager", "Customer Expansion Manager", "Renewal Manager", "Upsell Manager", "Cross-sell Manager",
    
    // Sales Leadership
    "Sales Team Lead", "Sales Supervisor", "Assistant Sales Manager", "District Sales Manager", "Area Sales Manager", "Zone Sales Manager", "International Sales Manager",
    "Sales Development Manager", "Inside Sales Manager", "Outside Sales Manager", "Enterprise Sales Director", "Commercial Sales Director", "Strategic Sales Director",
    
    // Emerging Sales
    "Social Selling Specialist", "Digital Sales Representative", "E-commerce Sales Manager", "Online Sales Manager", "Virtual Sales Representative", "Remote Sales Manager",
    "AI Sales Specialist", "Sales Automation Manager", "Revenue Operations Manager", "Sales Technology Manager", "CRM Manager", "Sales Stack Manager"
  ],

  hr: [
    // HR Leadership
    "HR Manager", "Senior HR Manager", "HR Director", "VP of HR", "Chief Human Resources Officer", "CHRO", "Head of HR", "HR Business Partner", "Senior HR Business Partner",
    
    // Talent Acquisition
    "Recruiter", "Senior Recruiter", "Lead Recruiter", "Principal Recruiter", "Technical Recruiter", "Executive Recruiter", "Healthcare Recruiter", "Engineering Recruiter",
    "Talent Acquisition Manager", "Talent Acquisition Director", "Talent Acquisition Specialist", "Talent Acquisition Coordinator", "Talent Acquisition Partner",
    "Sourcing Specialist", "Talent Sourcer", "Research Recruiter", "Headhunter", "Executive Search Consultant", "Recruitment Consultant", "Staffing Consultant",
    
    // HR Operations
    "HR Generalist", "HR Specialist", "HR Coordinator", "HR Administrator", "HR Assistant", "HR Operations Manager", "HR Operations Director", "HR Operations Specialist",
    "People Operations Manager", "People Operations Director", "People Operations Specialist", "Employee Relations Manager", "Employee Relations Specialist",
    
    // Compensation & Benefits
    "Compensation Manager", "Compensation Director", "Compensation Analyst", "Total Rewards Manager", "Total Rewards Director", "Benefits Manager", "Benefits Director",
    "Benefits Administrator", "Benefits Specialist", "Payroll Manager", "Payroll Director", "Payroll Specialist", "Payroll Administrator", "HRIS Manager", "HRIS Administrator",
    
    // Learning & Development
    "Training Manager", "Training Director", "Learning and Development Manager", "L&D Manager", "L&D Director", "Training Specialist", "Training Coordinator",
    "Organizational Development Manager", "OD Manager", "OD Director", "Talent Development Manager", "Talent Development Director", "Career Development Manager",
    "Leadership Development Manager", "Management Development Manager", "Skills Development Manager", "Performance Management Manager", "Performance Management Specialist",
    
    // Employee Experience
    "Employee Engagement Manager", "Employee Experience Manager", "Culture Manager", "Culture Director", "Workplace Experience Manager", "Internal Communications Manager",
    "Employee Communications Manager", "Change Management Manager", "Change Management Director", "Diversity and Inclusion Manager", "D&I Manager", "D&I Director",
    "Diversity Manager", "Inclusion Manager", "Equity Manager", "Belonging Manager", "DEI Manager", "DEI Director", "Chief Diversity Officer",
    
    // Specialized HR
    "HR Analyst", "HR Data Analyst", "People Analytics Manager", "People Analytics Director", "Workforce Analytics Manager", "HR Metrics Manager", "HR Reporting Manager",
    "Onboarding Manager", "Onboarding Specialist", "Offboarding Specialist", "Exit Interview Specialist", "Background Check Specialist", "Reference Check Specialist",
    "HR Compliance Manager", "HR Compliance Director", "Employment Law Specialist", "Labor Relations Manager", "Labor Relations Director", "Union Relations Manager",
    
    // Consulting & Advisory
    "HR Consultant", "HR Business Consultant", "People Consultant", "Talent Consultant", "HR Advisory", "Fractional HR Manager", "Interim HR Manager", "HR Contractor",
    "Executive Coach", "Leadership Coach", "Career Coach", "Performance Coach", "Management Coach", "Team Coach", "Organizational Coach",
    
    // Emerging HR
    "People Technology Manager", "HR Technology Manager", "HRIS Manager", "HR Systems Manager", "HR Automation Manager", "People Operations Analyst",
    "Remote Work Manager", "Hybrid Work Manager", "Future of Work Manager", "Digital HR Manager", "HR Innovation Manager", "People Science Manager"
  ],

  finance: [
    // Finance Leadership
    "CFO", "Chief Financial Officer", "VP of Finance", "Finance Director", "Controller", "Assistant Controller", "Finance Manager", "Senior Finance Manager",
    
    // Financial Analysis
    "Financial Analyst", "Senior Financial Analyst", "Lead Financial Analyst", "Principal Financial Analyst", "Finance Analyst", "Business Analyst", "Investment Analyst",
    "Budget Analyst", "Cost Analyst", "Pricing Analyst", "Revenue Analyst", "Profitability Analyst", "Variance Analyst", "Trend Analyst", "Forecasting Analyst",
    
    // Accounting
    "Accountant", "Senior Accountant", "Staff Accountant", "Public Accountant", "Management Accountant", "Cost Accountant", "Tax Accountant", "Forensic Accountant",
    "Accounting Manager", "Accounting Director", "Accounting Supervisor", "Accounting Clerk", "Bookkeeper", "Accounting Assistant", "Accounts Payable Specialist",
    "Accounts Receivable Specialist", "General Ledger Accountant", "Fixed Assets Accountant", "Payroll Accountant", "Revenue Accountant", "Expense Accountant",
    
    // Financial Planning & Analysis
    "FP&A Manager", "FP&A Director", "FP&A Analyst", "Financial Planning Manager", "Financial Planning Director", "Financial Planning Analyst",
    "Strategic Planning Manager", "Strategic Planning Director", "Strategic Planning Analyst", "Business Planning Manager", "Corporate Planning Manager",
    
    // Treasury & Risk
    "Treasury Manager", "Treasury Director", "Treasurer", "Cash Management Manager", "Risk Manager", "Risk Director", "Risk Analyst", "Credit Risk Manager",
    "Market Risk Manager", "Operational Risk Manager", "Compliance Manager", "Regulatory Compliance Manager", "Financial Compliance Manager",
    
    // Tax & Audit
    "Tax Manager", "Tax Director", "Tax Analyst", "Tax Specialist", "Tax Preparer", "Tax Consultant", "International Tax Manager", "Corporate Tax Manager",
    "Audit Manager", "Audit Director", "Internal Auditor", "External Auditor", "Senior Auditor", "Audit Analyst", "Compliance Auditor", "IT Auditor",
    
    // Investment & Banking
    "Investment Manager", "Investment Director", "Investment Analyst", "Portfolio Manager", "Asset Manager", "Fund Manager", "Hedge Fund Manager",
    "Investment Banker", "Investment Banking Analyst", "Investment Banking Associate", "Investment Banking VP", "Investment Banking Director", "Investment Banking MD",
    "Private Equity Analyst", "Private Equity Associate", "Venture Capital Analyst", "Venture Capital Associate", "M&A Analyst", "M&A Associate",
    
    // Corporate Finance
    "Corporate Development Manager", "Corporate Development Director", "Corporate Finance Manager", "Corporate Finance Director", "Corporate Finance Analyst",
    "Capital Markets Manager", "Capital Markets Director", "Capital Markets Analyst", "Debt Capital Markets Analyst", "Equity Capital Markets Analyst",
    "Valuation Analyst", "Valuation Manager", "Business Valuation Analyst", "Financial Modeling Analyst", "Financial Modeling Manager",
    
    // Specialized Finance
    "Credit Analyst", "Credit Manager", "Credit Risk Analyst", "Loan Officer", "Mortgage Loan Officer", "Commercial Loan Officer", "Personal Banker",
    "Wealth Manager", "Financial Advisor", "Financial Planner", "Investment Advisor", "Private Wealth Manager", "Family Office Manager",
    "Insurance Analyst", "Insurance Underwriter", "Actuarial Analyst", "Actuary", "Pension Fund Manager", "Retirement Plan Manager",
    
    // Financial Technology
    "Fintech Analyst", "Financial Systems Analyst", "ERP Analyst", "Financial Reporting Analyst", "Financial Data Analyst", "Quantitative Analyst",
    "Algorithmic Trading Analyst", "High-Frequency Trading Analyst", "Derivatives Analyst", "Fixed Income Analyst", "Equity Research Analyst",
    
    // Emerging Finance
    "Cryptocurrency Analyst", "Blockchain Finance Analyst", "DeFi Analyst", "Digital Asset Manager", "ESG Analyst", "Sustainability Finance Manager",
    "Climate Finance Analyst", "Green Finance Manager", "Impact Investment Analyst", "Social Finance Manager", "Microfinance Manager"
  ],

  operations: [
    // Operations Leadership
    "COO", "Chief Operating Officer", "VP of Operations", "Operations Director", "Operations Manager", "Senior Operations Manager", "Operations Analyst",
    
    // Business Operations
    "Business Operations Manager", "Business Operations Director", "Business Operations Analyst", "Business Operations Specialist", "Operations Coordinator",
    "Operations Assistant", "Operations Administrator", "Operations Support Specialist", "Operations Research Analyst", "Operational Excellence Manager",
    
    // Process & Quality
    "Process Improvement Manager", "Process Improvement Director", "Process Improvement Analyst", "Process Engineer", "Process Optimization Manager",
    "Quality Manager", "Quality Director", "Quality Analyst", "Quality Assurance Manager", "Quality Control Manager", "Quality Engineer",
    "Lean Manager", "Lean Director", "Lean Specialist", "Six Sigma Manager", "Six Sigma Director", "Six Sigma Black Belt", "Six Sigma Green Belt",
    "Continuous Improvement Manager", "Operational Excellence Director", "Performance Improvement Manager", "Efficiency Manager",
    
    // Supply Chain & Logistics
    "Supply Chain Manager", "Supply Chain Director", "Supply Chain Analyst", "Supply Chain Coordinator", "Supply Chain Specialist", "Supply Chain Planner",
    "Logistics Manager", "Logistics Director", "Logistics Analyst", "Logistics Coordinator", "Transportation Manager", "Distribution Manager",
    "Warehouse Manager", "Warehouse Director", "Inventory Manager", "Inventory Director", "Inventory Analyst", "Inventory Control Manager",
    "Procurement Manager", "Procurement Director", "Procurement Analyst", "Procurement Specialist", "Sourcing Manager", "Sourcing Director",
    "Vendor Manager", "Vendor Relations Manager", "Supplier Relations Manager", "Contract Manager", "Contract Specialist", "Strategic Sourcing Manager",
    
    // Facilities & Administration
    "Facilities Manager", "Facilities Director", "Facilities Coordinator", "Facilities Analyst", "Office Manager", "Administrative Manager",
    "Administrative Director", "Administrative Coordinator", "Administrative Assistant", "Executive Assistant", "Office Administrator",
    "Real Estate Manager", "Property Manager", "Lease Manager", "Space Planning Manager", "Workplace Services Manager", "Corporate Services Manager",
    
    // Project & Program Management
    "Project Manager", "Senior Project Manager", "Lead Project Manager", "Principal Project Manager", "Project Director", "Program Manager",
    "Program Director", "Portfolio Manager", "PMO Manager", "PMO Director", "Project Coordinator", "Project Administrator", "Project Analyst",
    "Scrum Master", "Agile Coach", "Product Owner", "Release Manager", "Delivery Manager", "Implementation Manager", "Change Manager",
    
    // Data & Analytics
    "Operations Analyst", "Business Intelligence Analyst", "Data Analyst", "Analytics Manager", "Analytics Director", "Reporting Manager",
    "Reporting Analyst", "Dashboard Developer", "KPI Manager", "Metrics Manager", "Performance Analyst", "Operational Reporting Manager",
    
    // Strategy & Planning
    "Strategy Manager", "Strategy Director", "Strategic Planning Manager", "Strategic Planning Director", "Strategic Planning Analyst",
    "Business Strategy Manager", "Corporate Strategy Manager", "Operations Strategy Manager", "Transformation Manager", "Change Management Manager",
    
    // Specialized Operations
    "Manufacturing Operations Manager", "Production Operations Manager", "Service Operations Manager", "Field Operations Manager", "Regional Operations Manager",
    "International Operations Manager", "E-commerce Operations Manager", "Digital Operations Manager", "Technology Operations Manager", "IT Operations Manager",
    "Customer Operations Manager", "Sales Operations Manager", "Marketing Operations Manager", "Revenue Operations Manager", "People Operations Manager",
    
    // Emerging Operations
    "Automation Manager", "Process Automation Manager", "RPA Manager", "AI Operations Manager", "Machine Learning Operations Manager", "MLOps Manager",
    "DevOps Manager", "Cloud Operations Manager", "Digital Transformation Manager", "Innovation Operations Manager", "Sustainability Operations Manager"
  ],

  data: [
    // Data Science & Analytics
    "Data Scientist", "Senior Data Scientist", "Lead Data Scientist", "Principal Data Scientist", "Staff Data Scientist", "Data Science Manager", "Data Science Director",
    "Applied Scientist", "Research Scientist", "Quantitative Analyst", "Statistician", "Biostatistician", "Econometrician", "Actuarial Scientist",
    
    // Data Analysis
    "Data Analyst", "Senior Data Analyst", "Lead Data Analyst", "Principal Data Analyst", "Business Intelligence Analyst", "BI Analyst", "Analytics Analyst",
    "Business Analyst", "Quantitative Analyst", "Statistical Analyst", "Research Analyst", "Market Research Analyst", "User Research Analyst",
    "Web Analytics Specialist", "Digital Analytics Manager", "Marketing Analytics Manager", "Sales Analytics Manager", "Operations Analytics Manager",
    
    // Data Engineering
    "Data Engineer", "Senior Data Engineer", "Lead Data Engineer", "Principal Data Engineer", "Data Engineering Manager", "Data Engineering Director",
    "Analytics Engineer", "ETL Developer", "Data Pipeline Engineer", "Big Data Engineer", "Cloud Data Engineer", "Data Integration Engineer",
    "Data Warehouse Engineer", "Data Lake Engineer", "Data Platform Engineer", "Data Infrastructure Engineer", "Streaming Data Engineer",
    
    // Machine Learning & AI
    "Machine Learning Engineer", "Senior ML Engineer", "Lead ML Engineer", "Principal ML Engineer", "ML Engineering Manager", "ML Engineering Director",
    "AI Engineer", "AI/ML Engineer", "Deep Learning Engineer", "Computer Vision Engineer", "Natural Language Processing Engineer", "NLP Engineer",
    "MLOps Engineer", "ML Platform Engineer", "Model Deployment Engineer", "AI Product Manager", "AI Research Scientist", "AI Ethics Specialist",
    
    // Data Management
    "Data Manager", "Data Director", "Chief Data Officer", "CDO", "Head of Data", "Data Governance Manager", "Data Governance Director",
    "Data Steward", "Data Curator", "Data Quality Manager", "Data Quality Analyst", "Master Data Manager", "Metadata Manager",
    "Database Administrator", "Database Manager", "Database Developer", "Database Architect", "Data Architect", "Data Modeler",
    
    // Business Intelligence
    "BI Manager", "BI Director", "BI Developer", "BI Analyst", "BI Specialist", "BI Architect", "BI Consultant", "Reporting Manager",
    "Reporting Analyst", "Dashboard Developer", "Data Visualization Specialist", "Tableau Developer", "Power BI Developer", "Qlik Developer",
    "Looker Developer", "Analytics Manager", "Analytics Director", "Self-Service Analytics Manager", "Embedded Analytics Developer",
    
    // Data Products & Strategy
    "Data Product Manager", "Data Strategy Manager", "Data Strategy Director", "Data Operations Manager", "Data Operations Director",
    "Data Analytics Manager", "Data Analytics Director", "Customer Analytics Manager", "People Analytics Manager", "Revenue Analytics Manager",
    "Risk Analytics Manager", "Fraud Analytics Manager", "Credit Analytics Manager", "Pricing Analytics Manager", "Supply Chain Analytics Manager",
    
    // Specialized Data Roles
    "Growth Analyst", "Performance Analyst", "Conversion Analyst", "Cohort Analyst", "Retention Analyst", "Churn Analyst", "A/B Testing Analyst",
    "Experimentation Manager", "Causal Inference Analyst", "Time Series Analyst", "Forecasting Analyst", "Demand Planning Analyst",
    "Financial Data Analyst", "Healthcare Data Analyst", "Clinical Data Analyst", "Genomics Data Analyst", "Bioinformatics Analyst",
    
    // Data Consulting
    "Data Consultant", "Analytics Consultant", "BI Consultant", "Data Science Consultant", "ML Consultant", "AI Consultant",
    "Data Strategy Consultant", "Data Transformation Consultant", "Data Modernization Consultant", "Data Migration Specialist",
    
    // Emerging Data
    "Data Ethics Manager", "AI Ethics Manager", "Responsible AI Manager", "Data Privacy Manager", "Data Security Analyst",
    "Real-time Analytics Engineer", "Edge Analytics Engineer", "IoT Data Engineer", "Geospatial Data Analyst", "Graph Data Scientist",
    "Blockchain Data Analyst", "Cryptocurrency Data Analyst", "Web3 Data Analyst", "Metaverse Data Analyst", "Climate Data Scientist"
  ],

  customer: [
    // Customer Success
    "Customer Success Manager", "Senior Customer Success Manager", "Lead Customer Success Manager", "Principal Customer Success Manager",
    "Customer Success Director", "VP of Customer Success", "Chief Customer Officer", "Head of Customer Success", "Customer Success Analyst",
    "Customer Success Representative", "Customer Success Specialist", "Customer Success Coordinator", "Customer Success Associate",
    "Client Success Manager", "Client Success Director", "Account Success Manager", "Customer Onboarding Manager", "Customer Implementation Manager",
    "Customer Adoption Manager", "Customer Engagement Manager", "Customer Retention Manager", "Customer Expansion Manager", "Customer Renewal Manager",
    
    // Customer Support
    "Customer Support Manager", "Customer Support Director", "Customer Support Representative", "Customer Support Specialist", "Customer Support Agent",
    "Technical Support Manager", "Technical Support Director", "Technical Support Representative", "Technical Support Specialist", "Technical Support Engineer",
    "Help Desk Manager", "Help Desk Technician", "Help Desk Specialist", "IT Support Specialist", "Desktop Support Technician",
    "Customer Service Manager", "Customer Service Director", "Customer Service Representative", "Customer Service Agent", "Customer Service Specialist",
    
    // Customer Experience
    "Customer Experience Manager", "Customer Experience Director", "VP of Customer Experience", "Chief Experience Officer", "CX Manager",
    "Customer Experience Analyst", "Customer Experience Specialist", "Customer Experience Designer", "Customer Journey Manager", "Customer Journey Analyst",
    "Voice of Customer Manager", "Customer Insights Manager", "Customer Research Manager", "Customer Feedback Manager", "Customer Satisfaction Manager",
    "Net Promoter Score Manager", "Customer Loyalty Manager", "Customer Advocacy Manager", "Customer Community Manager", "Customer Program Manager",
    
    // Customer Operations
    "Customer Operations Manager", "Customer Operations Director", "Customer Operations Analyst", "Customer Operations Specialist", "Customer Operations Coordinator",
    "Support Operations Manager", "Support Operations Director", "Support Operations Analyst", "Contact Center Manager", "Call Center Manager",
    "Customer Service Operations Manager", "Customer Support Operations Manager", "Customer Success Operations Manager", "Customer Data Manager",
    
    // Specialized Customer Roles
    "Enterprise Customer Manager", "SMB Customer Manager", "Technical Account Manager", "Customer Solutions Manager", "Customer Integration Manager",
    "Customer Training Manager", "Customer Education Manager", "Customer Enablement Manager", "Customer Communications Manager", "Customer Marketing Manager",
    "Customer Health Manager", "Customer Risk Manager", "Customer Escalation Manager", "Customer Complaint Manager", "Customer Recovery Manager",
    
    // Customer Analytics
    "Customer Analytics Manager", "Customer Data Analyst", "Customer Behavior Analyst", "Customer Segmentation Analyst", "Customer Lifetime Value Analyst",
    "Churn Analytics Manager", "Retention Analytics Manager", "Customer Usage Analyst", "Customer Engagement Analyst", "Customer Satisfaction Analyst",
    
    // Emerging Customer
    "Digital Customer Manager", "Omnichannel Customer Manager", "Self-Service Customer Manager", "AI Customer Experience Manager", "Chatbot Manager",
    "Voice Customer Experience Manager", "Social Customer Care Manager", "Mobile Customer Experience Manager", "In-App Customer Success Manager"
  ],

  executive: [
    // C-Suite
    "CEO", "Chief Executive Officer", "President", "Executive Chairman", "Chairman", "Founder", "Co-Founder", "Managing Director",
    "COO", "Chief Operating Officer", "CTO", "Chief Technology Officer", "CIO", "Chief Information Officer", "CDO", "Chief Digital Officer",
    "CFO", "Chief Financial Officer", "CMO", "Chief Marketing Officer", "CHRO", "Chief Human Resources Officer", "CPO", "Chief Product Officer",
    "CSO", "Chief Strategy Officer", "Chief Security Officer", "Chief Sales Officer", "CCO", "Chief Customer Officer", "Chief Commercial Officer",
    "Chief Data Officer", "Chief Analytics Officer", "Chief Innovation Officer", "Chief Transformation Officer", "Chief Revenue Officer",
    "Chief People Officer", "Chief Experience Officer", "Chief Growth Officer", "Chief Sustainability Officer", "Chief Diversity Officer",
    
    // Vice Presidents
    "Vice President", "Senior Vice President", "Executive Vice President", "VP of Engineering", "VP of Product", "VP of Sales", "VP of Marketing",
    "VP of Operations", "VP of Finance", "VP of HR", "VP of Customer Success", "VP of Business Development", "VP of Strategy", "VP of Digital",
    "VP of Technology", "VP of Data", "VP of Analytics", "VP of Innovation", "VP of Transformation", "VP of Quality", "VP of Compliance",
    
    // Directors
    "Executive Director", "Managing Director", "General Manager", "Regional General Manager", "Country Manager", "Division Manager",
    "Business Unit Director", "Functional Director", "Department Head", "Practice Lead", "Practice Director", "Service Line Director",
    
    // Board & Governance
    "Board Member", "Board Director", "Independent Director", "Non-Executive Director", "Chairman of the Board", "Board Chair",
    "Board Observer", "Advisory Board Member", "Board Advisor", "Board Consultant", "Corporate Secretary", "Governance Officer",
    
    // Partners & Ownership
    "Partner", "Senior Partner", "Managing Partner", "Equity Partner", "General Partner", "Limited Partner", "Principal", "Senior Principal",
    "Shareholder", "Stakeholder", "Investor", "Angel Investor", "Venture Partner", "Investment Partner", "Strategic Partner",
    
    // Emerging Executive
    "Chief AI Officer", "Chief Metaverse Officer", "Chief Web3 Officer", "Chief Blockchain Officer", "Chief Robotics Officer",
    "Chief Automation Officer", "Chief Digital Transformation Officer", "Chief Customer Experience Officer", "Chief Culture Officer",
    "Chief Happiness Officer", "Chief Wellness Officer", "Chief Remote Work Officer", "Chief Future Officer", "Chief Visionary Officer"
  ],

  consulting: [
    // Management Consulting
    "Management Consultant", "Senior Management Consultant", "Principal Consultant", "Partner", "Managing Director", "Engagement Manager",
    "Strategy Consultant", "Operations Consultant", "Technology Consultant", "Digital Consultant", "Transformation Consultant", "Change Management Consultant",
    "Business Consultant", "Process Consultant", "Performance Consultant", "Efficiency Consultant", "Optimization Consultant", "Innovation Consultant",
    
    // Specialized Consulting
    "IT Consultant", "Software Consultant", "Cloud Consultant", "Cybersecurity Consultant", "Data Consultant", "Analytics Consultant",
    "Digital Transformation Consultant", "Automation Consultant", "AI Consultant", "Machine Learning Consultant", "Blockchain Consultant",
    "Financial Consultant", "Tax Consultant", "Audit Consultant", "Risk Consultant", "Compliance Consultant", "Regulatory Consultant",
    
    // Industry Consulting
    "Healthcare Consultant", "Financial Services Consultant", "Manufacturing Consultant", "Retail Consultant", "Energy Consultant",
    "Government Consultant", "Nonprofit Consultant", "Education Consultant", "Real Estate Consultant", "Hospitality Consultant",
    "Supply Chain Consultant", "Logistics Consultant", "HR Consultant", "Talent Consultant", "Executive Search Consultant",
    
    // Functional Consulting
    "Sales Consultant", "Marketing Consultant", "Brand Consultant", "PR Consultant", "Communications Consultant", "Training Consultant",
    "Leadership Consultant", "Organizational Development Consultant", "Culture Consultant", "Employee Experience Consultant",
    "Customer Experience Consultant", "Service Design Consultant", "Product Consultant", "Innovation Consultant", "Growth Consultant",
    
    // Independent Consulting
    "Freelance Consultant", "Independent Consultant", "Solo Consultant", "Boutique Consultant", "Interim Manager", "Fractional Executive",
    "Subject Matter Expert", "Thought Leader", "Industry Expert", "Domain Expert", "Specialist Consultant", "Niche Consultant"
  ],

  legal: [
    // Legal Leadership
    "Chief Legal Officer", "General Counsel", "Associate General Counsel", "Deputy General Counsel", "Legal Director", "Head of Legal",
    "Legal Manager", "Legal Operations Manager", "Legal Operations Director", "Legal Project Manager", "Legal Program Manager",
    
    // Lawyers & Attorneys
    "Attorney", "Lawyer", "Senior Attorney", "Staff Attorney", "Associate Attorney", "Partner", "Senior Partner", "Managing Partner",
    "Corporate Attorney", "Corporate Lawyer", "In-House Counsel", "Outside Counsel", "Contract Attorney", "Freelance Attorney",
    
    // Specialized Legal
    "Corporate Lawyer", "Commercial Lawyer", "Business Lawyer", "Contract Lawyer", "Employment Lawyer", "Labor Lawyer", "IP Lawyer",
    "Intellectual Property Attorney", "Patent Attorney", "Trademark Attorney", "Copyright Attorney", "Privacy Lawyer", "Data Protection Attorney",
    "Compliance Attorney", "Regulatory Attorney", "Securities Lawyer", "Tax Attorney", "Real Estate Attorney", "Environmental Lawyer",
    "Healthcare Lawyer", "Technology Lawyer", "Software Lawyer", "Cybersecurity Lawyer", "Fintech Lawyer", "Blockchain Lawyer",
    
    // Legal Support
    "Paralegal", "Senior Paralegal", "Legal Assistant", "Legal Secretary", "Legal Analyst", "Legal Research Assistant", "Legal Coordinator",
    "Contract Manager", "Contract Specialist", "Contract Analyst", "Legal Compliance Manager", "Legal Risk Manager", "Legal Auditor",
    "Legal Consultant", "Legal Advisor", "Legal Counsel", "Legal Specialist", "Legal Officer", "Compliance Officer", "Ethics Officer",
    
    // Litigation & Disputes
    "Litigation Attorney", "Trial Lawyer", "Dispute Resolution Attorney", "Arbitration Attorney", "Mediation Attorney", "Class Action Attorney",
    "Civil Litigation Attorney", "Criminal Defense Attorney", "Prosecutor", "Public Defender", "Government Attorney", "Regulatory Attorney",
    
    // Emerging Legal
    "Legal Technology Manager", "Legal Innovation Manager", "Legal Transformation Manager", "AI Legal Specialist", "Legal Automation Manager",
    "Alternative Legal Services Provider", "Legal Process Outsourcing Manager", "Legal Vendor Manager", "Legal Procurement Manager"
  ],

  healthcare: [
    // Medical Professionals
    "Physician", "Doctor", "Medical Doctor", "Surgeon", "Specialist", "Consultant", "Attending Physician", "Resident", "Fellow",
    "Cardiologist", "Oncologist", "Neurologist", "Orthopedist", "Pediatrician", "Psychiatrist", "Radiologist", "Anesthesiologist",
    "Emergency Medicine Physician", "Family Medicine Physician", "Internal Medicine Physician", "Dermatologist", "Ophthalmologist",
    
    // Nursing
    "Registered Nurse", "Licensed Practical Nurse", "Nurse Practitioner", "Physician Assistant", "Nurse Manager", "Charge Nurse",
    "Clinical Nurse", "ICU Nurse", "OR Nurse", "ER Nurse", "Pediatric Nurse", "Geriatric Nurse", "Psychiatric Nurse", "Oncology Nurse",
    
    // Allied Health
    "Physical Therapist", "Occupational Therapist", "Speech Therapist", "Respiratory Therapist", "Pharmacist", "Clinical Pharmacist",
    "Medical Technologist", "Laboratory Technician", "Radiology Technician", "Ultrasound Technician", "MRI Technician", "CT Technician",
    "Medical Assistant", "Certified Nursing Assistant", "Patient Care Technician", "Medical Scribe", "Medical Interpreter",
    
    // Healthcare Administration
    "Healthcare Administrator", "Hospital Administrator", "Clinic Manager", "Practice Manager", "Medical Office Manager", "Department Manager",
    "Healthcare Operations Manager", "Healthcare Quality Manager", "Healthcare Compliance Manager", "Healthcare Risk Manager",
    "Healthcare IT Manager", "Healthcare Data Manager", "Healthcare Analytics Manager", "Healthcare Project Manager",
    
    // Healthcare Technology
    "Healthcare Software Developer", "Healthcare Data Analyst", "Healthcare Business Analyst", "Healthcare Systems Analyst",
    "Healthcare Implementation Manager", "Healthcare Consultant", "Healthcare Informatics Manager", "Telemedicine Manager",
    "Digital Health Manager", "Healthcare AI Manager", "Healthcare Automation Manager", "Healthcare Innovation Manager",
    
    // Public Health
    "Public Health Officer", "Epidemiologist", "Biostatistician", "Health Policy Analyst", "Community Health Manager", "Population Health Manager",
    "Health Educator", "Health Promotion Manager", "Environmental Health Manager", "Occupational Health Manager", "Global Health Manager",
    
    // Mental Health
    "Psychologist", "Clinical Psychologist", "Counselor", "Therapist", "Marriage and Family Therapist", "Substance Abuse Counselor",
    "Mental Health Counselor", "Behavioral Health Manager", "Psychiatric Social Worker", "Art Therapist", "Music Therapist",
    
    // Healthcare Business
    "Healthcare Business Development Manager", "Healthcare Sales Representative", "Medical Device Sales Representative", "Pharmaceutical Sales Representative",
    "Healthcare Marketing Manager", "Healthcare Product Manager", "Healthcare Strategy Manager", "Healthcare Operations Manager"
  ],

  education: [
    // Academic Leadership
    "President", "Chancellor", "Provost", "Vice President", "Dean", "Associate Dean", "Assistant Dean", "Department Chair", "Department Head",
    "Academic Director", "Program Director", "Center Director", "Institute Director", "Research Director", "Academic Affairs Director",
    
    // Faculty & Teaching
    "Professor", "Associate Professor", "Assistant Professor", "Adjunct Professor", "Clinical Professor", "Research Professor", "Visiting Professor",
    "Lecturer", "Senior Lecturer", "Instructor", "Teaching Assistant", "Graduate Teaching Assistant", "Postdoctoral Fellow", "Research Fellow",
    "Teacher", "Elementary Teacher", "Middle School Teacher", "High School Teacher", "Special Education Teacher", "ESL Teacher",
    "Substitute Teacher", "Tutor", "Online Instructor", "Distance Learning Instructor", "Curriculum Developer", "Instructional Designer",
    
    // Student Services
    "Student Affairs Director", "Student Services Manager", "Academic Advisor", "Student Advisor", "Career Counselor", "Academic Counselor",
    "Admissions Officer", "Admissions Director", "Enrollment Manager", "Registrar", "Financial Aid Officer", "Student Life Director",
    "Residence Life Director", "Student Activities Director", "Student Engagement Manager", "Student Success Manager", "Retention Manager",
    
    // Administration
    "Education Administrator", "School Administrator", "Principal", "Assistant Principal", "Superintendent", "Assistant Superintendent",
    "School Board Member", "Education Director", "Academic Operations Manager", "Education Program Manager", "Education Project Manager",
    "Education Coordinator", "Education Specialist", "Education Analyst", "Education Consultant", "Education Researcher",
    
    // Educational Technology
    "Educational Technology Manager", "Learning Management System Administrator", "Instructional Technology Specialist", "EdTech Manager",
    "E-Learning Developer", "Online Learning Manager", "Digital Learning Manager", "Educational Software Developer", "Learning Analytics Manager",
    "Educational Data Analyst", "Learning Experience Designer", "Educational Content Developer", "Educational Media Producer",
    
    // Training & Development
    "Training Manager", "Training Director", "Corporate Trainer", "Professional Development Manager", "Learning and Development Manager",
    "Training Specialist", "Training Coordinator", "Instructional Designer", "Curriculum Developer", "Training Analyst", "Training Consultant",
    
    // Specialized Education
    "Special Education Teacher", "Special Education Director", "Reading Specialist", "Math Specialist", "Science Teacher", "Language Teacher",
    "Art Teacher", "Music Teacher", "Physical Education Teacher", "Health Teacher", "Library Media Specialist", "School Librarian",
    "School Counselor", "School Psychologist", "School Social Worker", "School Nurse", "Speech Pathologist", "Occupational Therapist",
    
    // Educational Research
    "Education Researcher", "Educational Psychologist", "Learning Scientist", "Assessment Specialist", "Evaluation Specialist", "Measurement Specialist",
    "Educational Policy Analyst", "Education Policy Researcher", "Curriculum Researcher", "Education Data Scientist", "Learning Analytics Researcher",
    
    // Emerging Education
    "AI Education Specialist", "Virtual Reality Education Manager", "Gamification Specialist", "Personalized Learning Manager", "Adaptive Learning Manager",
    "Microlearning Specialist", "Mobile Learning Manager", "Social Learning Manager", "Peer-to-Peer Learning Manager", "Competency-Based Learning Manager"
  ],

  nonprofit: [
    // Nonprofit Leadership
    "Executive Director", "CEO", "President", "Founder", "Co-Founder", "Board Chair", "Board Member", "Trustee", "Advisory Board Member",
    "Managing Director", "Operations Director", "Program Director", "Development Director", "Communications Director", "Finance Director",
    
    // Fundraising & Development
    "Development Manager", "Fundraising Manager", "Donor Relations Manager", "Major Gifts Manager", "Planned Giving Manager", "Grant Writer",
    "Grant Manager", "Corporate Partnerships Manager", "Foundation Relations Manager", "Alumni Relations Manager", "Donor Stewardship Manager",
    "Campaign Manager", "Special Events Manager", "Auction Manager", "Gala Manager", "Peer-to-Peer Fundraising Manager", "Online Fundraising Manager",
    
    // Program Management
    "Program Manager", "Program Coordinator", "Program Specialist", "Program Officer", "Project Manager", "Case Manager", "Social Worker",
    "Community Outreach Manager", "Volunteer Manager", "Volunteer Coordinator", "Community Organizer", "Advocacy Manager", "Policy Manager",
    
    // Operations & Administration
    "Operations Manager", "Administrative Manager", "Finance Manager", "Accounting Manager", "Human Resources Manager", "Office Manager",
    "Data Manager", "Research Manager", "Evaluation Manager", "Quality Assurance Manager", "Compliance Manager", "Risk Manager",
    
    // Communications & Marketing
    "Communications Manager", "Marketing Manager", "Public Relations Manager", "Social Media Manager", "Content Manager", "Digital Marketing Manager",
    "Brand Manager", "Creative Director", "Graphic Designer", "Web Manager", "Newsletter Manager", "Media Relations Manager",
    
    // Specialized Nonprofit
    "Grant Administrator", "Donor Database Manager", "Prospect Researcher", "Wealth Screening Specialist", "Stewardship Coordinator",
    "Volunteer Recruiter", "Volunteer Trainer", "Community Engagement Manager", "Stakeholder Relations Manager", "Partnership Manager",
    "Impact Measurement Manager", "Outcomes Manager", "Program Evaluator", "Social Impact Analyst", "Beneficiary Relations Manager",
    
    // Sector-Specific
    "Healthcare Nonprofit Manager", "Education Nonprofit Manager", "Environmental Nonprofit Manager", "Arts Nonprofit Manager",
    "Religious Nonprofit Manager", "International Development Manager", "Human Rights Manager", "Animal Welfare Manager",
    "Disaster Relief Manager", "Humanitarian Aid Manager", "Social Services Manager", "Community Development Manager",
    
    // Emerging Nonprofit
    "Digital Transformation Manager", "Innovation Manager", "Social Enterprise Manager", "Impact Investing Manager", "ESG Manager",
    "Sustainability Manager", "Diversity and Inclusion Manager", "Equity Manager", "Justice Manager", "Advocacy Technology Manager"
  ],

  media: [
    // Editorial & Content
    "Editor", "Senior Editor", "Managing Editor", "Executive Editor", "Editor-in-Chief", "Editorial Director", "Content Editor", "Copy Editor",
    "Journalist", "Reporter", "Staff Writer", "Freelance Writer", "News Reporter", "Investigative Reporter", "Sports Reporter", "Entertainment Reporter",
    "Correspondent", "Foreign Correspondent", "War Correspondent", "Political Correspondent", "Business Correspondent", "Science Correspondent",
    "Content Creator", "Content Producer", "Content Manager", "Content Strategist", "Content Director", "Editorial Producer", "Digital Content Manager",
    
    // Broadcasting & Television
    "News Anchor", "TV Host", "Radio Host", "Presenter", "News Producer", "TV Producer", "Radio Producer", "Executive Producer",
    "Television Director", "News Director", "Programming Director", "Broadcast Engineer", "Camera Operator", "Audio Engineer", "Video Editor",
    "Broadcast Journalist", "Field Producer", "Assignment Editor", "Newsroom Manager", "Control Room Operator", "Master Control Operator",
    
    // Digital & Social Media
    "Social Media Manager", "Digital Media Manager", "Social Media Producer", "Community Manager", "Influencer Manager", "Creator Economy Manager",
    "Digital Marketing Manager", "SEO Manager", "Content Marketing Manager", "Email Marketing Manager", "Growth Marketing Manager",
    "Podcast Producer", "Podcast Host", "Audio Producer", "YouTube Creator", "TikTok Creator", "Instagram Creator", "Twitch Streamer",
    
    // Publishing
    "Publisher", "Book Publisher", "Magazine Publisher", "Newspaper Publisher", "Digital Publisher", "Publishing Director", "Acquisitions Editor",
    "Developmental Editor", "Line Editor", "Proofreader", "Literary Agent", "Rights Manager", "Licensing Manager", "Distribution Manager",
    "Production Manager", "Art Director", "Book Designer", "Cover Designer", "Typesetter", "Indexer", "Translator", "Ghostwriter",
    
    // Advertising & Marketing
    "Advertising Manager", "Media Planner", "Media Buyer", "Account Manager", "Creative Director", "Art Director", "Copywriter",
    "Brand Manager", "Marketing Director", "Public Relations Manager", "Communications Manager", "Crisis Communications Manager",
    "Event Manager", "Promotions Manager", "Sponsorship Manager", "Partnership Manager", "Affiliate Manager", "Influencer Relations Manager",
    
    // Production & Technical
    "Film Producer", "Film Director", "Cinematographer", "Director of Photography", "Sound Engineer", "Lighting Engineer", "Set Designer",
    "Costume Designer", "Makeup Artist", "Script Supervisor", "Location Manager", "Casting Director", "Stunt Coordinator", "Special Effects Artist",
    "Post-Production Manager", "Video Editor", "Audio Editor", "Color Grader", "Visual Effects Artist", "Animation Director", "Motion Graphics Designer",
    
    // Media Business
    "Media Sales Manager", "Advertising Sales Manager", "Subscription Manager", "Circulation Manager", "Audience Development Manager",
    "Revenue Manager", "Business Development Manager", "Strategic Partnerships Manager", "Licensing Manager", "Distribution Manager",
    "Media Research Manager", "Audience Research Manager", "Analytics Manager", "Data Analyst", "Media Planner", "Media Strategist",
    
    // Emerging Media
    "Streaming Manager", "OTT Platform Manager", "Creator Economy Manager", "NFT Media Manager", "Web3 Content Manager", "Metaverse Content Creator",
    "AR/VR Content Producer", "Interactive Media Producer", "Gaming Content Creator", "Esports Manager", "Live Streaming Manager",
    "AI Content Manager", "Synthetic Media Manager", "Deepfake Detection Specialist", "Media Literacy Manager", "Fact-Checking Manager"
  ],

  real_estate: [
    // Sales & Brokerage
    "Real Estate Agent", "Real Estate Broker", "Senior Real Estate Agent", "Real Estate Sales Manager", "Listing Agent", "Buyer's Agent", "Dual Agent",
    "Commercial Real Estate Agent", "Commercial Real Estate Broker", "Industrial Real Estate Agent", "Land Broker", "Real Estate Auctioneer",

    // Property Management
    "Property Manager", "Senior Property Manager", "Regional Property Manager", "Residential Property Manager", "Commercial Property Manager",
    "Asset Manager", "Portfolio Manager", "Facilities Manager", "Building Manager", "Community Manager", "HOA Manager", "Property Supervisor",

    // Development & Investment
    "Real Estate Developer", "Real Estate Development Manager", "Real Estate Project Manager", "Land Developer", "Mixed-Use Developer",
    "Real Estate Investment Manager", "Real Estate Analyst", "Real Estate Financial Analyst", "Acquisitions Manager", "Dispositions Manager",
    "Real Estate Fund Manager", "REIT Manager", "Real Estate Asset Manager", "Real Estate Portfolio Manager",

    // Valuation & Research
    "Real Estate Appraiser", "Senior Appraiser", "Commercial Appraiser", "Residential Appraiser", "Real Estate Valuation Analyst",
    "Real Estate Market Analyst", "Real Estate Research Analyst", "Real Estate Data Analyst", "GIS Analyst",

    // Mortgage & Finance
    "Mortgage Broker", "Mortgage Loan Officer", "Loan Originator", "Mortgage Underwriter", "Real Estate Finance Manager",
    "Title Officer", "Escrow Officer", "Closing Agent", "Real Estate Attorney",

    // Operations & Support
    "Real Estate Operations Manager", "Leasing Manager", "Leasing Consultant", "Leasing Agent", "Real Estate Coordinator",
    "Real Estate Marketing Manager", "Real Estate Technology Manager", "PropTech Manager", "Real Estate CRM Manager"
  ],

  construction: [
    // Leadership & Management
    "Construction Manager", "Senior Construction Manager", "Construction Director", "VP of Construction", "Chief Construction Officer",
    "Project Manager", "Senior Project Manager", "Construction Project Director", "Program Manager", "Construction Executive",

    // Engineering
    "Civil Engineer", "Structural Engineer", "Geotechnical Engineer", "Environmental Engineer", "Mechanical Engineer", "Electrical Engineer",
    "Construction Engineer", "Site Engineer", "Field Engineer", "Design Engineer", "Value Engineering Manager",

    // Architecture & Planning
    "Architect", "Senior Architect", "Principal Architect", "Project Architect", "Design Architect", "Urban Planner", "Urban Designer",
    "Interior Architect", "Landscape Architect", "BIM Manager", "BIM Coordinator", "CAD Designer", "Drafter",

    // Site Operations
    "Site Supervisor", "Site Manager", "General Superintendent", "Superintendent", "Foreman", "Site Coordinator",
    "Safety Manager", "HSE Manager", "Safety Officer", "Quality Control Manager", "Quality Assurance Manager",

    // Estimating & Contracts
    "Quantity Surveyor", "Senior Quantity Surveyor", "Cost Estimator", "Construction Estimator", "Cost Manager", "Cost Planner",
    "Contracts Manager", "Procurement Manager", "Subcontract Manager", "Bid Manager", "Tendering Manager",

    // Specialist Trades
    "Electrical Superintendent", "Mechanical Superintendent", "Plumbing Superintendent", "HVAC Manager", "Structural Steel Manager",
    "Concrete Manager", "Finishing Manager", "Fit-Out Manager", "Facade Manager", "MEP Manager",

    // Technology
    "Construction Technology Manager", "Digital Construction Manager", "Construction Data Analyst", "Construction Software Manager"
  ],

  manufacturing: [
    // Leadership
    "Plant Manager", "Factory Manager", "Manufacturing Director", "VP of Manufacturing", "Chief Manufacturing Officer",
    "Operations Manager", "Production Manager", "Senior Production Manager", "Manufacturing Manager",

    // Engineering
    "Manufacturing Engineer", "Industrial Engineer", "Process Engineer", "Production Engineer", "Tooling Engineer",
    "Mechanical Engineer", "Automation Engineer", "Robotics Engineer", "Maintenance Engineer", "Reliability Engineer",
    "Quality Engineer", "Metrology Engineer", "Test Engineer", "Design for Manufacturability Engineer",

    // Production & Operations
    "Production Supervisor", "Shift Supervisor", "Production Coordinator", "Production Planner", "Scheduler",
    "Capacity Planner", "Demand Planner", "Materials Planner", "Production Control Manager",

    // Quality
    "Quality Manager", "Quality Director", "Quality Control Inspector", "Quality Assurance Specialist", "Quality Systems Manager",
    "Six Sigma Black Belt", "Six Sigma Green Belt", "Lean Manufacturing Manager", "Continuous Improvement Manager",

    // Supply Chain & Procurement
    "Supply Chain Manager", "Procurement Manager", "Sourcing Manager", "Materials Manager", "Inventory Manager",
    "Warehouse Manager", "Logistics Manager", "Import/Export Manager", "Customs Manager",

    // Maintenance & Safety
    "Maintenance Manager", "Maintenance Supervisor", "Predictive Maintenance Manager", "EHS Manager", "Safety Manager",
    "Environmental Manager", "Compliance Manager", "Regulatory Affairs Manager",

    // Technology
    "Manufacturing IT Manager", "MES Manager", "ERP Manager", "Industry 4.0 Manager", "Smart Factory Manager",
    "Digital Manufacturing Manager", "Manufacturing Data Analyst", "Manufacturing Systems Engineer"
  ],

  hospitality: [
    // Hotel Management
    "Hotel Manager", "General Manager", "Assistant General Manager", "Hotel Director", "Resort Manager",
    "Front Office Manager", "Rooms Division Manager", "Housekeeping Manager", "Concierge Manager", "Guest Relations Manager",
    "Revenue Manager", "Yield Manager", "Hotel Sales Manager", "Hotel Marketing Manager",

    // Food & Beverage
    "F&B Manager", "Food and Beverage Manager", "F&B Director", "Restaurant Manager", "Bar Manager", "Banquet Manager",
    "Executive Chef", "Head Chef", "Sous Chef", "Pastry Chef", "Chef de Partie", "Catering Manager",

    // Events
    "Event Manager", "Event Coordinator", "Event Director", "Banquet Manager", "Conference Manager", "Wedding Planner",
    "Events Sales Manager", "MICE Manager", "Corporate Events Manager",

    // Travel & Tourism
    "Travel Agent", "Travel Consultant", "Travel Manager", "Tour Manager", "Tour Operator", "Destination Manager",
    "Travel Coordinator", "Corporate Travel Manager", "Leisure Travel Manager", "Cruise Manager",

    // Spa & Recreation
    "Spa Manager", "Spa Director", "Recreation Manager", "Activities Manager", "Fitness Manager", "Golf Manager",

    // Operations
    "Hospitality Operations Manager", "Property Operations Manager", "Revenue Operations Manager",
    "Guest Experience Manager", "Customer Experience Manager", "Loyalty Manager", "Hospitality Technology Manager"
  ],

  retail: [
    // Store Operations
    "Store Manager", "Assistant Store Manager", "Store Director", "Retail Manager", "Retail Director",
    "Area Manager", "District Manager", "Regional Manager", "Zone Manager", "Multi-Site Manager",

    // Merchandising & Buying
    "Buyer", "Senior Buyer", "Merchandise Planner", "Merchandising Manager", "Merchandising Director",
    "Category Manager", "Category Director", "Assortment Manager", "Space Planner", "Visual Merchandiser",
    "Visual Merchandising Manager", "Display Manager", "Planogram Manager",

    // E-commerce & Digital
    "E-commerce Manager", "E-commerce Director", "Online Retail Manager", "D2C Manager", "Marketplace Manager",
    "Digital Commerce Manager", "Omnichannel Manager", "Click and Collect Manager", "Digital Retail Manager",

    // Supply Chain & Inventory
    "Retail Operations Manager", "Inventory Manager", "Stock Manager", "Replenishment Manager", "Demand Planner",
    "Supply Chain Manager", "Logistics Manager", "Distribution Manager", "Fulfillment Manager",

    // Customer & Sales
    "Retail Sales Manager", "Customer Experience Manager", "Loyalty Program Manager", "CRM Manager",
    "Clienteling Manager", "Personal Shopper", "Styling Manager",

    // Marketing
    "Retail Marketing Manager", "Trade Marketing Manager", "Promotions Manager", "Pricing Manager",
    "Brand Manager", "Campaign Manager", "Retail Media Manager",

    // Technology
    "Retail Technology Manager", "POS Manager", "Retail Systems Manager", "Retail Data Analyst", "Loss Prevention Manager"
  ],

  research: [
    // Academic Research
    "Research Scientist", "Senior Research Scientist", "Principal Research Scientist", "Staff Research Scientist",
    "Research Fellow", "Postdoctoral Researcher", "Research Associate", "Research Assistant", "Lab Manager",

    // Life Sciences
    "Biologist", "Biochemist", "Molecular Biologist", "Cell Biologist", "Geneticist", "Genomics Scientist",
    "Clinical Research Coordinator", "Clinical Research Manager", "Clinical Trial Manager", "Regulatory Affairs Manager",
    "Pharmacologist", "Toxicologist", "Drug Discovery Scientist", "Computational Biologist", "Bioinformatician",

    // Chemistry & Materials
    "Chemist", "Senior Chemist", "Analytical Chemist", "Organic Chemist", "Materials Scientist", "Polymer Scientist",
    "R&D Chemist", "Formulation Scientist", "Process Chemist", "Quality Control Chemist",

    // Physics & Engineering Science
    "Physicist", "Applied Physicist", "Research Engineer", "R&D Engineer", "R&D Manager", "R&D Director",
    "Innovation Manager", "Technology Research Manager", "Applied Research Manager",

    // Social & Market Research
    "Market Research Manager", "Market Research Director", "Research Manager", "Consumer Insights Manager",
    "UX Researcher", "User Research Manager", "Survey Research Manager", "Social Researcher", "Policy Researcher",

    // Technology Research
    "AI Researcher", "Machine Learning Researcher", "Computer Science Researcher", "Cybersecurity Researcher",
    "Quantum Computing Researcher", "Robotics Researcher", "HCI Researcher", "NLP Researcher"
  ],

  government: [
    // Public Administration
    "Public Administrator", "City Manager", "County Manager", "Government Program Manager", "Policy Analyst",
    "Policy Manager", "Policy Director", "Public Policy Manager", "Regulatory Affairs Manager", "Compliance Officer",

    // Government Operations
    "Government Operations Manager", "Budget Analyst", "Budget Manager", "Government Finance Manager",
    "Procurement Officer", "Contracting Officer", "Grants Manager", "Program Officer",

    // Law Enforcement & Defense
    "Police Officer", "Detective", "Sheriff", "Law Enforcement Manager", "Intelligence Analyst",
    "Defense Analyst", "Military Officer", "Security Analyst", "Emergency Management Director",

    // Government Services
    "Social Services Manager", "Benefits Administrator", "Case Manager", "Public Health Officer",
    "Environmental Officer", "Planning Officer", "Zoning Manager", "Permit Manager",

    // Government Technology
    "Government IT Manager", "Government Data Analyst", "Cybersecurity Officer", "Digital Government Manager",
    "e-Government Manager", "Government CIO", "Government CTO",

    // Diplomatic & International
    "Diplomat", "Foreign Service Officer", "Political Officer", "Economic Officer", "Consular Officer",
    "International Affairs Manager", "Government Affairs Manager", "Public Affairs Officer", "Lobbyist"
  ],

  energy: [
    // Oil & Gas
    "Petroleum Engineer", "Reservoir Engineer", "Drilling Engineer", "Production Engineer", "Completions Engineer",
    "Geologist", "Geophysicist", "Seismic Analyst", "Petrophysicist", "Subsurface Manager",
    "Oil and Gas Operations Manager", "Offshore Manager", "Pipeline Engineer", "Refinery Manager",

    // Renewable Energy
    "Renewable Energy Manager", "Solar Energy Engineer", "Wind Energy Engineer", "Solar Project Manager",
    "Wind Farm Manager", "Energy Storage Engineer", "Battery Technology Engineer", "Hydrogen Engineer",
    "Bioenergy Manager", "Hydropower Engineer", "Geothermal Engineer",

    // Power & Utilities
    "Power Engineer", "Electrical Engineer", "Grid Engineer", "Transmission Engineer", "Distribution Engineer",
    "Utilities Manager", "Energy Operations Manager", "Plant Operations Manager", "Energy Analyst",

    // Energy Management & Sustainability
    "Energy Manager", "Energy Director", "Chief Sustainability Officer", "Sustainability Manager",
    "Carbon Manager", "ESG Manager", "Environmental Manager", "Climate Strategy Manager",
    "Energy Efficiency Manager", "Green Building Manager", "LEED Manager",

    // Energy Trading & Finance
    "Energy Trader", "Energy Analyst", "Commodity Analyst", "Power Markets Analyst", "Energy Risk Manager",
    "Energy Finance Manager", "Carbon Credit Manager", "Emissions Trading Manager",

    // Technology
    "Energy Technology Manager", "Smart Grid Engineer", "Energy Automation Manager", "SCADA Engineer",
    "Energy Data Analyst", "Energy Informatics Manager", "Digital Energy Manager"
  ],

  logistics: [
    // Freight & Transport
    "Freight Broker", "Freight Manager", "Freight Coordinator", "Transportation Manager", "Transportation Director",
    "Fleet Manager", "Fleet Director", "Driver Manager", "Dispatch Manager", "Dispatcher",
    "Trucking Manager", "Carrier Relations Manager", "Rate Analyst", "Load Planner",

    // Shipping & Trade
    "Shipping Manager", "Import Manager", "Export Manager", "Import/Export Manager", "Customs Manager",
    "Customs Broker", "Trade Compliance Manager", "Global Trade Manager", "Cross-border Manager",
    "Ocean Freight Manager", "Air Freight Manager", "Freight Forwarder",

    // Warehouse & Distribution
    "Warehouse Manager", "Warehouse Director", "Distribution Manager", "Distribution Director",
    "Fulfillment Manager", "Fulfillment Director", "Sortation Manager", "DC Manager",
    "Inventory Manager", "Stock Manager", "Receiving Manager", "Shipping Manager",

    // Last Mile & Delivery
    "Last Mile Manager", "Delivery Manager", "Courier Manager", "Delivery Operations Manager",
    "Route Planner", "Route Optimization Manager", "Network Design Manager",

    // 3PL & Supply Chain
    "3PL Manager", "Third-Party Logistics Manager", "Contract Logistics Manager", "Outsourced Logistics Manager",
    "Supply Chain Manager", "Supply Chain Director", "Procurement Manager", "Sourcing Manager",

    // Technology
    "Logistics Technology Manager", "TMS Manager", "WMS Manager", "Logistics Data Analyst",
    "Supply Chain Analyst", "Logistics Systems Manager", "Last Mile Technology Manager"
  ]
};

// Helper function to get all job roles as a flat array
export const getAllJobRoles = () => {
  return Object.values(BASE_JOB_ROLES).flat();
};

// Helper function to get job roles by category
export const getJobRolesByCategory = (category) => {
  return BASE_JOB_ROLES[category] || [];
};

// Helper function to get all categories
export const getJobRoleCategories = () => {
  return Object.keys(BASE_JOB_ROLES);
};

// Helper function to get job roles count by category
export const getJobRolesCountByCategory = () => {
  const counts = {};
  Object.entries(BASE_JOB_ROLES).forEach(([category, roles]) => {
    counts[category] = roles.length;
  });
  return counts;
};

// Helper function to get total job roles count
export const getTotalJobRolesCount = () => {
  return getAllJobRoles().length;
};

// Helper function to filter and sort job roles based on input
export const filterJobRoles = (input, maxResults = 20) => {
  if (!input || input.length < 2) return [];
  
  const allRoles = getAllJobRoles();
  const inputLower = input.toLowerCase();
  
  // Create scoring system for better relevance
  const scoredRoles = allRoles.map(role => {
    const roleLower = role.toLowerCase();
    let score = 0;
    
    // Exact match gets highest score
    if (roleLower === inputLower) score += 1000;
    
    // Starts with input gets high score
    else if (roleLower.startsWith(inputLower)) score += 500;
    
    // Contains input as whole word gets medium score
    else if (roleLower.includes(` ${inputLower} `) || roleLower.includes(` ${inputLower}`)) score += 300;
    
    // Contains input gets lower score
    else if (roleLower.includes(inputLower)) score += 100;

    // Bonus for shorter roles (more specific matches) — only when there's a real match
    if (score > 0) score += (50 - Math.min(role.length, 50));
    
    return { role, score };
  });
  
  // Filter out roles with score 0 and sort by score
  return scoredRoles
    .filter(item => item.score > 0)
    .sort((a, b) => b.score - a.score || a.role.localeCompare(b.role))
    .slice(0, maxResults)
    .map(item => item.role);
};

// Helper function to find which category a job role belongs to
export const findJobRoleCategory = (jobRole) => {
  for (const [category, roles] of Object.entries(BASE_JOB_ROLES)) {
    if (roles.includes(jobRole)) {
      return category;
    }
  }
  return null;
};

// Helper function to find similar job roles based on keywords
export const findSimilarJobRoles = (jobRole, maxResults = 10) => {
  const category = findJobRoleCategory(jobRole);
  if (!category) return [];
  
  const categoryRoles = BASE_JOB_ROLES[category];
  const keywords = jobRole.toLowerCase().split(' ');
  
  const similarRoles = categoryRoles
    .filter(role => role !== jobRole)
    .map(role => {
      const roleLower = role.toLowerCase();
      const matchCount = keywords.reduce((count, keyword) => {
        return count + (roleLower.includes(keyword) ? 1 : 0);
      }, 0);
      return { role, matchCount };
    })
    .filter(item => item.matchCount > 0)
    .sort((a, b) => b.matchCount - a.matchCount || a.role.localeCompare(b.role))
    .slice(0, maxResults)
    .map(item => item.role);
  
  return similarRoles;
};

// Helper function to get job roles by seniority level
export const getJobRolesBySeniority = (seniorityLevel) => {
  const allRoles = getAllJobRoles();
  const seniorityKeywords = {
    entry: ['junior', 'entry', 'assistant', 'associate', 'coordinator', 'specialist', 'analyst', 'representative'],
    mid: ['manager', 'lead', 'senior', 'principal', 'supervisor', 'team lead'],
    senior: ['director', 'head of', 'vp', 'vice president', 'chief', 'cto', 'ceo', 'cfo', 'cmo', 'coo'],
    executive: ['ceo', 'cto', 'cfo', 'cmo', 'coo', 'president', 'founder', 'partner', 'board']
  };
  
  const keywords = seniorityKeywords[seniorityLevel.toLowerCase()] || [];
  if (keywords.length === 0) return [];
  
  return allRoles.filter(role => {
    const roleLower = role.toLowerCase();
    return keywords.some(keyword => roleLower.includes(keyword));
  });
};

// Helper function to search job roles across multiple criteria
export const searchJobRoles = (criteria) => {
  const {
    query = '',
    category = '',
    seniorityLevel = '',
    includeKeywords = [],
    excludeKeywords = [],
    maxResults = 50
  } = criteria;
  
  let results = getAllJobRoles();
  
  // Filter by category
  if (category) {
    results = getJobRolesByCategory(category);
  }
  
  // Filter by query
  if (query) {
    const queryLower = query.toLowerCase();
    results = results.filter(role => 
      role.toLowerCase().includes(queryLower)
    );
  }
  
  // Filter by seniority level
  if (seniorityLevel) {
    const seniorityRoles = getJobRolesBySeniority(seniorityLevel);
    results = results.filter(role => seniorityRoles.includes(role));
  }
  
  // Filter by include keywords
  if (includeKeywords.length > 0) {
    results = results.filter(role => {
      const roleLower = role.toLowerCase();
      return includeKeywords.some(keyword => roleLower.includes(keyword.toLowerCase()));
    });
  }
  
  // Filter by exclude keywords
  if (excludeKeywords.length > 0) {
    results = results.filter(role => {
      const roleLower = role.toLowerCase();
      return !excludeKeywords.some(keyword => roleLower.includes(keyword.toLowerCase()));
    });
  }
  
  // Sort and limit results
  return results
    .sort((a, b) => a.localeCompare(b))
    .slice(0, maxResults);
};

// Export job roles statistics
export const getJobRolesStatistics = () => {
  const stats = {
    totalRoles: getTotalJobRolesCount(),
    categoryCounts: getJobRolesCountByCategory(),
    categories: getJobRoleCategories(),
    averageRolesPerCategory: Math.round(getTotalJobRolesCount() / getJobRoleCategories().length),
    largestCategory: '',
    smallestCategory: ''
  };
  
  // Find largest and smallest categories
  const counts = Object.values(stats.categoryCounts);
  const maxCount = Math.max(...counts);
  const minCount = Math.min(...counts);
  
  stats.largestCategory = Object.entries(stats.categoryCounts)
    .find(([_, count]) => count === maxCount)?.[0] || '';
  
  stats.smallestCategory = Object.entries(stats.categoryCounts)
    .find(([_, count]) => count === minCount)?.[0] || '';
  
  return stats;
};